export { DateCell } from './date-cell';
export { TranslatedCell } from './translated-cell';
export { TagListCell } from './tag-list-cell';
export { UserLinkCell } from './user-link-cell';
export { DeleteActionCell } from './delete-action-cell';

/**
 * AG Grid valueFormatter that displays a fallback string for empty values.
 * Uses nullish coalescing — only catches null/undefined, not empty string or 0.
 * @param {import('ag-grid-community').ValueFormatterParams} params
 * @returns {string}
 */
export const textWithFallback = params => params.value ?? '-';
